import {
  TYPES_REQUEST,
  TYPES_SUCCESS,
  TYPES_FAILURE,
  TYPES_EDIT_REQUEST,
  TYPES_EDIT_SUCCESS,
  TYPES_EDIT_FAILURE,
  TYPES_EDIT_RESET,
  TYPES_RESET,

} from "../actions/types";

const initialState = {
  state: "idle",
};

export default function types(state = initialState, action) {
  switch (action.type) {
    case TYPES_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case TYPES_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case TYPES_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case TYPES_RESET:
      return {
        ...state,
        state: "idle",
      };


    default:
      return state;
  }
}

export function editTypes(state = initialState, action) {
  switch (action.type) {
    case TYPES_EDIT_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case TYPES_EDIT_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case TYPES_EDIT_FAILURE:
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };

    case TYPES_EDIT_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}
